export default {
  "container": "_container_zkiiou",
  "checkbox": "_checkbox_zkiiou",
  "checkbox-text": "_checkbox-text_zkiiou"
};
